import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PanelBar, PanelBarItem, StackLayout } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { Group } from '../../components/Group';
import GroupModal from '../../components/GroupModal';
import Dialog from '../../components/Dialog/Dialog';
import { createGroup, deleteGroup as deleteGroupApi, updateGroup } from '../../actions';
import GroupUserModal from '../../components/GroupUserModal';
import { formCloser } from '../../utils/formCloser.js';

const DashboardGroups = () => {
  const { token, user } = useSelector(state => state.authReducer);
  const { groups } = useSelector(state => state.groupsReducer);
  const [groupsBySite, setGroupsBySite] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [editable, setEditable] = useState(true);
  const [showDialog, setShowDialog] = useState(false);
  const [showUserModal, setShowUserModal] = useState(false);
  const [dialogProps, setDialogProps] = useState({});
  const [selectedGroup, setSelectedGroup] = useState({});
  const [rows, setRows] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    let groupsBySiteObj = {};    
    groups.forEach(group => {
      if (groupsBySiteObj[group.site.name]) {
        groupsBySiteObj[group.site.name].push(group);
      } else {
        groupsBySiteObj[group.site.name] = [group];
      }
    });
    setGroupsBySite(groupsBySiteObj);
    // forces into 3 cards per row but I think I could've just used flex wrap to account for this
    // check out https://www.telerik.com/kendo-react-ui/components/layout/card/ sometime
    const groupsPerRow = 3;

    let newRows = groups.reduce((previous, current) => {
      let currentRow = previous[previous.length - 1];
      if (currentRow.length === groupsPerRow) {
        // the last row already has the max groups, so start a new row
        previous.push([current]);
      } else {
        currentRow.push(current);
      }

      return previous;
    }, [[]]);

    setRows(newRows);
  }, [groups]);

  const openGroupEditModal = (group) => {
    setSelectedGroup(group ? group : {});
    setShowModal(true);
  }

  const openGroupUserModal = (group, editable) => {
    setEditable(editable);
    setSelectedGroup(group ? group : {});
    setShowUserModal(true);
  }

  const groupDeleteBtnClicked = dataItem => {
    // prompt for confirmation

    setDialogProps({
      title: `Delete Group`,
      text: `Are you sure you want to delete ${dataItem.name}?`,
      onConfirm: () => {
        dispatch(deleteGroupApi(dataItem.id, token, formCloser(setShowDialog)))
      },
      enableCancelBtn: true
    });

    setShowDialog(true);
  }

  const saveGroup = (group) => {
    const groupData = { name: group.name, enabled: true, siteId: user.site.id, users: group.Users }

    if (group.id) {
      // updating existing
      dispatch(updateGroup(group.id, groupData, token, formCloser(setShowModal)))
    } else {
      // creating new
      dispatch(createGroup(groupData, token, formCloser(setShowModal)))
    }
  }

  const saveGroupUsers = (event, data, groupId) => {
    dispatch(updateGroup(groupId, data, token, formCloser(setShowUserModal)));
  }

  return (
    <div id='groupTab'>
      {!user.viewOnly && !user.notificationOnly ? <Button
        className="k-button k-primary"
        style={{
          minHeight: 25,
          padding: '10px 20px',
          marginLeft: 15
        }}
        onClick={() => openGroupEditModal()}
        iconClass="k-icon k-i-add"
      >
        Create Group
      </Button> : null}
      <PanelBar className="k-primary" animation={false} expandMode={'multiple'} style={{ margin: '10px 15px', backgroundColor: 'rgb(223, 223, 223)', border: '0px' }} >
        {Object.entries(groupsBySite).map(groupSiteObj => {
            return <PanelBarItem className="k-primary" expanded={true} title={groupSiteObj[0]}>
              <StackLayout
                key={Math.floor(Math.random()*100)}
                orientation='horizontal'
                gap={15}
                style={{ margin: '15px', width: '100%', height: '100%', flexWrap: 'wrap' }}>
                {groupSiteObj[1].map(group => {
                return <Group
                  key={group.id}
                  group={group}
                  viewOnly={!user.viewOnly && !user.notificationOnly}
                  user={openGroupUserModal}
                  edit={openGroupEditModal}
                  delete={groupDeleteBtnClicked}
                />
              })}
              </StackLayout>
            </PanelBarItem>
          })}
      </PanelBar>
      {showModal && (
        <GroupModal
          item={selectedGroup}
          cancelEdit={() => setShowModal(false)}
          saveGroup={saveGroup}
        />
      )}

      {showUserModal && (
        <GroupUserModal
          item={selectedGroup}
          editable={editable}
          cancelEdit={() => setShowUserModal(false)}
          saveGroup={saveGroupUsers}
        />
      )}

      {showDialog &&
        <Dialog
          {...dialogProps}
          onClose={() => setShowDialog(false)}
        />}
    </div>
  )
}

export default DashboardGroups;